import {inject} from '@angular/core'
import {ResolveFn} from '@angular/router'
import {Observable} from 'rxjs'
import {User} from '../services/types'
import {UserService} from '../services/user.service'

export const resolvers: ResolveFn<User[]> = (): Observable<User[]> => {
  const userService = inject(UserService)
  return userService.getUsers()
}

export const officeResolver: ResolveFn<string[]> = (): Observable<string[]> => {
  const userService = inject(UserService)
  return userService.getOffices()
}